let host  = '//rule-platform.vip.com'
if (window.location.hostname === 'localhost') {
  host = ''
}
const apis = {
  getRootToSpecificLayer: {
    url: host + '/category/getRootToSpecificLayer',
    type: 'POST'
  },
  listHotKeywords: {
    url: host + '/hotkey/listHotKeywords'
  },
  getNoticeOverview: {
    url: host + '/notice/getNoticeOverview'
  },
  getRuleDetail: {
    url: host + '/rule/getRuleDetail'
  },
  searchCompletionSuggester: {
    url: host + '/search/getCompletionSuggester'
  },
  search: {
    url: host + '/search/searchRules'
  },
  searchStatistics: {
    url: host + '/search/searchStatistics'
  },
  getNoticeRootCategoryId: {
    url: host + '/notice/getNoticeRootCategoryId'
  },
  getCategoryNode: {
    url: host + '/category/getCategoryNode'
  },
  signIn: {
    url: host + '/user/signIn'
  },
  getUserInfo: {
    url: host + '/user/getUserInfo'
  },
  getRuleOverviewCount: {
    url: host + '/rule/getRuleOverviewCount'
  },
  getNoticeOverviewCount: {
    url: host + '/notice/getNoticeOverviewCount'
  },
  signOut: {
    url: host + '/user/signOut'
  },
  getRuleOverviews: {
    url: host + '/rule/getRuleOverviews'
  },
  queryViolationAnnouncement: {
    url: host + '/mpRule/queryViolationAnnouncement'
  }
}
export default apis
